<template>
  <div class="tel-swiper">
    <!-- 在线轮播 -->
    <div class="tel-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img class="image" src="https://xthk-cms-admin.oss-cn-shenzhen.aliyuncs.com/cms-img/online-1.jpg" alt />
        </div>
        <div class="swiper-slide">
          <img class="image" src="https://xthk-cms-admin.oss-cn-shenzhen.aliyuncs.com/cms-img/online-2.jpg" alt />
        </div>
        <div class="swiper-slide">
          <img class="image" src="https://xthk-cms-admin.oss-cn-shenzhen.aliyuncs.com/cms-img/online-3.jpg" alt />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper } from 'vue-awesome-swiper';
export default {
  data() {
    return {
      mySwiper: {}
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.mySwiper = new Swiper('.tel-container', {
        // direction: "vertical",
        autoplay: true, //可选选项，自动滑动
        // loop : true,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,
        lazyLoading: true,
        autoplayDisableOnInteraction: false //用户操作swiper之后，是否禁止autoplay。默认为true
      });
    }
  }
};
</script>
<style lang="less">
.tel-swiper {
  height: 100%;
  width: 100%;
  .tel-container {
    width: 100%;
    height: 100%;
  }
  .image {
    width: 278px;
    height: 496px;
  }
}
</style>
